import {
  EXPLORE_CONFIRM_BUILD_MANUALLY,
  EXPLORE_CONFIRM_PASTE_QUESTIONNAIRE,
} from "@digital-twins/shared-types";

export type ExploreConfirmLocalAction = "paste" | "manual";

/**
 * Local starts on the explore confirm card. Honoured only when the active
 * card offered the sentinel, so Other-box text cannot trigger them.
 */
export function resolveExploreConfirmAction(
  value: string,
  activeOptionValues: ReadonlyArray<string>,
): ExploreConfirmLocalAction | null {
  if (
    value === EXPLORE_CONFIRM_PASTE_QUESTIONNAIRE &&
    activeOptionValues.includes(EXPLORE_CONFIRM_PASTE_QUESTIONNAIRE)
  ) {
    return "paste";
  }
  if (
    value === EXPLORE_CONFIRM_BUILD_MANUALLY &&
    activeOptionValues.includes(EXPLORE_CONFIRM_BUILD_MANUALLY)
  ) {
    return "manual";
  }
  return null;
}
